import * as React from 'react';

export const CloseIcon12 = () => (
  // eslint-disable-next-line react/forbid-elements
  <svg aria-hidden="true" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 6.528 9.472 10 10 9.47 6.528 6 10 2.528 9.472 2 6 5.47 2.528 2 2 2.528 5.472 6 2 9.472l.528.528L6 6.528Z"
      fill="currentColor"
    ></path>
  </svg>
);
